"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _uuid = require("uuid");

var _Table = _interopRequireDefault(require("../Table/Table"));

var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));

var _elements = require("../../styles/elements");

var _TableWithCheckbox = require("./TableWithCheckbox.styles");

var _util = require("../../util");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var TableWithCheckbox = function TableWithCheckbox(_ref) {
  var className = _ref.className,
      gapToCheckbox = _ref.gapToCheckbox,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["className", "gapToCheckbox"]);
  var selectionHeader = (0, _react.useCallback)(function (_ref2) {
    var getToggleAllPageRowsSelectedProps = _ref2.getToggleAllPageRowsSelectedProps;

    // The header can use the table's getToggleAllRowsSelectedProps method
    // to render a checkbox
    var _getToggleAllPageRows = getToggleAllPageRowsSelectedProps(),
        checked = _getToggleAllPageRows.checked,
        indeterminate = _getToggleAllPageRows.indeterminate,
        onCheckedChange = _getToggleAllPageRows.onChange;

    return (0, _jsxRuntime.jsx)(_Checkbox["default"], {
      id: (0, _uuid.v4)(),
      className: "grui block",
      checked: checked,
      indeterminate: indeterminate,
      onChange: onCheckedChange
    });
  }, []);
  var useCustomHook = (0, _react.useCallback)(function (hooks) {
    var selectionColumn = _objectSpread(_objectSpread({}, _Table["default"].RowSelection.column), {}, {
      Header: selectionHeader,
      id: 'selection',
      width: (0, _util.rem)(32 + gapToCheckbox)
    });

    hooks.visibleColumns.push(function (originalColumns) {
      return [// Add a column for selection
      selectionColumn].concat((0, _toConsumableArray2["default"])(originalColumns));
    });
  }, [gapToCheckbox, selectionHeader]);
  return (0, _jsxRuntime.jsx)(_Table["default"], _objectSpread({
    className: className,
    css: [_elements.text.styles.textDark, _TableWithCheckbox.styles.base, process.env.NODE_ENV === "production" ? "" : ";label:TableWithCheckbox;"],
    useCustomHook: useCustomHook
  }, props));
};

TableWithCheckbox.propTypes = {
  className: _propTypes.string,

  /**
   * The cell content's spacing to checkbox
   */
  gapToCheckbox: _propTypes.number
};
TableWithCheckbox.defaultProps = {
  className: undefined,
  gapToCheckbox: 8
};
var _default = TableWithCheckbox;
exports["default"] = _default;
//# sourceMappingURL=TableWithCheckbox.js.map